<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <dialog-table-page ref="userTable" @btnclick="userBthClick" :pageData="userData"></dialog-table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData">
      <template v-slot:level="update">
        <!--任务列表-->
        <LEVEL :update="update"></LEVEL>
      </template>
    </UPDATE>
    <UPDATE  ref="userUpdate"  @submit="userSubmit" :updateData="userUpdateData"></UPDATE>
    <UPDATE  ref="importChildUpdate"  @submit="userSubmit" :updateData="importUpdateData" @uploadFile="uploadFile"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import LEVEL from '@/views/crs36/commission/level.vue'
  import DateUtil from '@/utils/IM/tradeDataUtil'
  import Url from '@/views/crs36/util/url'
  import Qs from 'qs'
  import dialogTablePage from '@/components/page/dialogTable.vue'
  let status = {1:"未开始",2:"进行中",3:"已结束",4:"待审核"}
  let platform = {"GTS2":"PTS","MT5":"MT5"}
  let zoneList = {}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE,
      LEVEL,
      dialogTablePage
    },
    methods: {
      uploadFile(col,result){
        col.data = (result || []).join(",");
      },
      /*表格按钮点击事件*/
      userBthClick(clickName, row){
        if(clickName == "addUser"){
          //人工报名
          row.activeId = row.id;
          this.$refs.userUpdate.open(row);
        }else if(clickName == "importUser") {
          row.activeId = row.id;
          this.$refs.importChildUpdate.open(row);
        }
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          row.time = [row.startTime,row.endTime];
          row.type = row.type.split(",");
          row.symbol = row.symbol.split(",");
          row.level = JSON.parse(row.level);
          this.$refs.childUpdate.open(row);
        }else if(clickName == "copy"){
          row.id = null;
          row.status = 4;
          row.time = [row.startTime,row.endTime];
          row.type = row.type.split(",");
          row.symbol = row.symbol.split(",");
          row.level = JSON.parse(row.level);
          this.$refs.childUpdate.open(row);
        }else if(clickName == "delete"){
          this.dataChanage(Url.commission.active.del,{id:row.id},res => {
            if (res.code == 0) {
              this.$message.success("suc");
              this.$refs.childTable.defaultGetData(this.queryData);
            } else {
              this.$message.error(res.message);
            }
          })
        }else if(clickName == "apply"){
          this.dataChanage(Url.commission.active.apply,{id:row.id},res => {
            if (res.code == 0) {
              this.$message.success("suc");
              this.$refs.childTable.defaultGetData(this.queryData);
            } else {
              this.$message.error(res.message);
            }
          })
        }else if(clickName == "addUser"){
          //人工报名
          this.userData.sync = true;
          let data = {id:row.id};
          this.$refs.userTable.defaultQueryData(data);
        }else if(clickName == "end"){
          //结束
          this.dataChanage(Url.commission.active.end,{id:row.id},res => {
            if (res.code == 0) {
              this.$message.success("suc");
              this.$refs.childTable.defaultGetData(this.queryData);
            } else {
              this.$message.error(res.message);
            }
          })
        }else if(clickName == "user"){
          //参与用户
          this.$router.push({path: '/crs36/commission/user',query:{label:"CRS36",activeId:row.id}});
        }else if(clickName == "record"){
          //发放记录
          this.$router.push({path: '/crs36/commission/day',query:{label:"CRS36",activeId:row.id}});
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        model.startTime = model.time[0];
        model.endTime = model.time[1];
        model.type = model.type.join(",");
        model.symbol = model.symbol.join(",");
        model.level = JSON.stringify(model.level);
        //根据是否包含id更新还是添加
        this.dataChanage(Url.commission.active.edit,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      /*新增或跟提交数据触发事件*/
      userSubmit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(Url.commission.user.import,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
          if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
            if(fail && (typeof fail == 'function')) fail(res);
        })
      },
      typeChanage(model,cols){
        let col = {};
        for (let i in cols){
          if (cols[i].field == "symbol") col = cols[i];
        }
        if (col.data.length > 0){
          let symbolArr = [];
          let data = [];
          for (let i in this.productionList) {
            if (model.type.indexOf(this.productionList[i].zone) >= 0) symbolArr.push(this.productionList[i].symbol);
          }
          for (let i in symbolArr){
            if (col.data.indexOf(symbolArr[i]) >= 0) data.push(symbolArr[i]);
          }
          this.$set(col,"data",data);
        }
    }
    },
    created() {
      if(this.productionList.length == 0){
        this.axios.post(Url.commission.active.getProduction, Qs.stringify({})).then(res => {
          if (res.code == 0){
            const arr = res.result;
            for (let i in arr) {
              this.productionList.push(arr[i]);
              zoneList[arr[i].zone] = arr[i].zoneName || "other";
            }
          }
        })
      }
    },
    data () {
      return {
        queryData:{},
        productionList:[],
        zonlist:{},
        userUpdateData:{
          cols:[
            { title: '活动开始时间', field: 'startTime',hidden: true},
            { title: '活动结束时间', field: 'endTime',hidden: true},
            { title: 'status', field: 'status',data:4,hidden: true},
            { title: 'closeTime', field: 'closeTime',data:0,hidden: true},
            { title: 'total', field: 'total',data:0,hidden: true},
            { title: '活动id', field: 'activeId'},
            { title: '层级id', field: 'levelId'},
            { title: '层级名称', field: 'name'},
            { title: '客户账号', field: 'account'},
          ]
        },
        importUpdateData:{
          cols:[
            { title: '活动开始时间', field: 'startTime',hidden: true},
            { title: '活动结束时间', field: 'endTime',hidden: true},
            { title: 'status', field: 'status',data:4,hidden: true},
            { title: 'closeTime', field: 'closeTime',data:0,hidden: true},
            { title: 'total', field: 'total',data:0,hidden: true},
            { title: '活动id', field: 'activeId',hidden: true},
            { title: '层级id', field: 'levelId',hidden: true},
            { title: '层级名称', field: 'name',hidden: true},
            { title: "上传用户", field: 'account',type:11,action:Url.pushMsg.uploadTemplate,downUrl:"https://static.chwenda.com/source/downloadModel/消息推送用户模板.xlsx"},

          ]
        },
        /*新增或更新*/
        updateData:{
          cols:[
                  { title: '活动id', field: 'id',hidden: true},
                  { title: '活动名称', field: 'name'},
                  { title: '活动时间', field: 'time',type: 9,data:[],required:true},
                  { title: '状态', field: 'status',data: 4,hidden: true},
                  { title: '交易平台', field: 'platform',type: 2,optionList: platform,data:"GTS2"},
                  { title: '产品类型', field: 'type',type: 2,data:[],multiple:true,optionList: zoneList,change: this.typeChanage},
                  { title: '产品名称', field: 'symbol',type: 2,multiple:true,data:[],optionListObjRender:(model,col)=>{
                      let symbolArr = {};
                      if (model.type.length == 0) return symbolArr;
                      for (let i in this.productionList) {
                        if (model.type.indexOf(this.productionList[i].zone) >= 0) symbolArr[this.productionList[i].symbol] = this.productionList[i].name;
                      }
                      return symbolArr;
                    }},
                  { title: '层级规则', field: 'level',type:10,slot:'level',data:[{id:1}]},
              ]
        },

        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: '活动id', field: 'activeId',data:this.$route.query.activeId},
            {click:"查询",auth:"crs36.commission.query"},
            {click:"新增",auth:"crs36.commission.add"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.commission.active.query, //请求路径和参数
          sequence: true,
          cols: [
                    { title: '活动id', field: 'id'},
                    { title: '活动名称', field: 'name'},
                    { title: '抽奖活动开始时间', field: 'startTime',render:(data,full)=>{
                        return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                      }},
                    { title: '抽奖活动结束时间', field: 'endTime',render:(data,full)=>{
                        return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                      }},
                    { title: '状态', field: 'status',render:(data,full)=>{
                        return status[data];
                      }},
                    { title: '交易平台', field: 'platform',render:(data,full)=>{
                        return platform[data];
                      }},
                    { title: '创建者', field: 'creator'},
                    { title: '创建时间', field: 'createTime',render:(data,full)=>{
                        return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                      }},
                    { title: '审批人', field: 'approval'},
                    { title: '审批时间', field: 'approvalTime',render:(data,full)=>{
                        return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                      }},
                    { title: '结束人', field: 'stoper'},
                    { title: '结束时间', field: 'stopTime',render:(data,full)=>{
                        return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                      }},
                    {title: window.$t('crs36.bt.operation'),width: 400,btnClick:[
                        {name: window.$t('crs36.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit",auth:"crs36.commission.update"},
                        {name: "复制",click:"copy",type:"primary",icon:"el-icon-edit",auth:"crs36.commission.copy"},
                        {name: "审批",click:"apply",type:"primary",icon:"el-icon-edit",confirm:true,hidden:(data,full)=>{
                            return full.status != 4;
                          },auth:"crs36.commission.apply"},
                        {name: "删除",click:"delete",type:"primary",icon:"el-icon-delete",auth:"crs36.commission.delete"},
                        {name: "人工报名",click:"addUser",type:"primary",icon:"el-icon-edit",hidden:(data,full)=>{
                            return full.status == 4 || full.status == 3;
                          },br:true,auth:"crs36.commission.addUser"},
                        {name: "结束",click:"end",type:"primary",icon:"el-icon-edit",confirm:true,hidden:(data,full)=>{
                            return full.status == 4 || full.status == 3;
                          },auth:"crs36.commission.end"},
                        {name: "参与用户",click:"user",type:"primary",icon:"el-icon-edit",hidden:(data,full)=>{
                            return full.status == 4;
                          },auth:"crs36.commission.user"},
                        {name: "发放记录",click:"record",type:"primary",icon:"el-icon-edit",hidden:(data,full)=>{
                            return full.status == 4;
                          },auth:"crs36.commission.record"},

                      ]
                    },
                ]
        },
        userData: {
          queryUrl: Url.commission.active.levelList, //请求路径和参数
          sequence: true,
          isPage: false,
          sync: false,
          cols: [
            { title: '层级id', field: 'levelId'},
            { title: '层级名称', field: 'name'},
            { title: '返现上限', field: 'limit'},
            //{ title: '活动结束时间', field: 'endTime',hidden: true},
            { title: '返现比例（%）', field: 'ratio'},
            {title: window.$t('crs36.bt.operation'),width: 250,btnClick:[
                {name: "添加客户",click:"addUser",type:"primary",icon:"el-icon-edit",auth:"crs36.commission.addUser"},
                {name: "上传参与名单",click:"importUser",type:"primary",icon:"el-icon-edit",auth:"crs36.commission.importUser"},
              ]
            },
          ]
        }
      }
    }
  }
</script>
